// Tides – Under-Keel Clearance exercises (Townsville, Bowen)
// Extracted from live WordPress block attributes (allships.com.au), tidesUnderKeelClearance
const tidesUnderKeelClearance = [
  {
    tabGroup: "exercises_ukc",
    tideform_published: true,
    tideform_description: "You arrive outside Townsville port on 24th of December at 05:20. Your vessel draws 2.5 metres and you require a UKC of 2 metres. Chartered depth at port entrance at lowest astronomical tide is 3.1 metres. What is the earliest time you can cross into the port?",
    tideform_tab_title: "Exercise 1 - Townsville",
    tideform_show_tidal_range: true,
    tideform_show_vessel_requirements: true,
    tideform_std_row1_tide: "LW",
    tideform_std_row1_time: "04:30",
    tideform_std_row1_height: "1.10",
    tideform_std_row2_tide: "HW",
    tideform_std_row2_time: "11:55",
    tideform_std_row2_height: "3.05",
    tideform_std_row3_tide: "LW",
    tideform_std_row3_time: "19:26",
    tideform_std_row3_height: "1.71",
    tideform_std_row4_tide: "HW",
    tideform_std_row4_time: "23:43",
    tideform_std_row4_height: "2.11",
    tideform_range_hw: "3.05",
    tideform_range_lw: "1.10",
    tideform_range_range: "1.95",
    tideform_vessel_ukc: "2.00",
    tideform_vessel_draught: "2.50",
    tideform_vessel_total: "4.50",
    tideform_vessel_charteddepth: "3.10",
    tideform_vessel_requiredheight: "2.40",
    tideform_show_tide_time: true,
    tideform_tide_time_extrawater: "1.30",
    tideform_tide_time_earliest: "10:10",
    tideform_show_secondary_port: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises_ukc",
    tideform_published: true,
    tideform_description: "You are scheduled to come off the slip after repairs in Bowen on 12th of September at 15:00. Your vessel draws 2.4 metres and you require a UKC of 1.0 metre. Chartered depth at port entrance at lowest astronomical tide is 1.5 metres. What is the latest time you can exit the port?",
    tideform_tab_title: "Exercise 2 - Bowen",
    tideform_show_tidal_range: true,
    tideform_show_vessel_requirements: true,
    tideform_std_row1_time: "00:01",
    tideform_std_row1_height: "2.35",
    tideform_std_row2_time: "06:47",
    tideform_std_row2_height: "0.79",
    tideform_std_row3_time: "13:51",
    tideform_std_row3_height: "2.60",
    tideform_std_row4_time: "19:54",
    tideform_std_row4_height: "1.40",
    tideform_range_hw: "2.60",
    tideform_range_lw: "1.40",
    tideform_range_range: "1.20",
    tideform_vessel_ukc: "1.0",
    tideform_vessel_draught: "2.4",
    tideform_vessel_total: "3.4",
    tideform_vessel_charteddepth: "1.5",
    tideform_vessel_requiredheight: "1.9",
    tideform_show_tide_time: true,
    tideform_tide_time_extrawater: "0.5",
    tideform_tide_time_earliest: "16:21",
    tideform_show_secondary_port: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_tide: "LW",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
];

export default tidesUnderKeelClearance;
